import { connect } from "react-redux";
import MainWrapper from "../components/MainWrapper";
import { queryStringToFilters } from "../utils/filters";
import * as selectors from "../selectors";
import * as actions from "../actions";

const isSmartphone = () => screen.width <= 768;

const mapStateToProps = state => {
  const filters = queryStringToFilters(location.search);
  return {
    districtsFilter: filters.districts,
    categoriesFilter: filters.categories,
    freetextFilter: filters.freetext,
    offbordersFilter: filters.offborders,

    institutions: selectors.getInstitutions(state),
    activeInstitution: selectors.getActiveInstitution(state),
    categories: selectors.getCategories(state),
    districts: selectors.getDistricts(state),
    isLoadingCategories: selectors.isLoadingCategories(state),
    isLoadingDistricts: selectors.isLoadingDistricts(state),
    isFetchingInstitutions: selectors.isFetchingInstitutions(state),
    isSmartphone: isSmartphone()
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onSetFilters: filters => dispatch(actions.setFilters(filters)),
    onSetActiveInstitution: institution_id =>
      dispatch(actions.setActiveInstitution(institution_id)),
    onLoadCategories: () => dispatch(actions.loadCategories()),
    onLoadDistricts: () => dispatch(actions.loadDistricts())
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MainWrapper);



/** WEBPACK FOOTER **
 ** ./src/containers/MainWrapperContainer.js
 **/